import React, { Fragment } from "react";
import logo from "../../images/harrison-loog.svg";
import logoWhite from "../../images/harrison-loog-white.svg";
import { Img } from "glamorous";

const Logo = ({ width = 100, height = 22, styles, white }) => {
  return (
    <Fragment>
      <Img
        width={width}
        height={height}
        css={styles}
        src={white ? logoWhite : logo}
        alt="Harrison"
      />
    </Fragment>
  );
};

export default Logo;



// WEBPACK FOOTER //
// ./src/components/logo/Logo.js